import { render, staticRenderFns } from "./montorStarticData.vue?vue&type=template&id=b31cb0e4&"
import script from "./montorStarticData.vue?vue&type=script&lang=js&"
export * from "./montorStarticData.vue?vue&type=script&lang=js&"
import style0 from "./montorStarticData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b31cb0e4')) {
      api.createRecord('b31cb0e4', component.options)
    } else {
      api.reload('b31cb0e4', component.options)
    }
    module.hot.accept("./montorStarticData.vue?vue&type=template&id=b31cb0e4&", function () {
      api.rerender('b31cb0e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/montorStarticData.vue"
export default component.exports